"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetConfigurationsResolver = exports.GetConfigurations = exports.PostSelectionsResolver = exports.PostSelections = exports.GetOptionsResolver = exports.GetOptions = exports.GetSpacesResolver = exports.GetSpaces = void 0;
const effect_1 = require("effect");
const HttpBody = __importStar(require("@effect/platform/HttpBody"));
const rison_1 = __importDefault(require("rison"));
const types_1 = require("../types");
const errors_1 = require("./errors");
const GetSpacesResponse = effect_1.Schema.Struct({
    spaces: types_1.ProductSpaces
});
class GetSpaces extends effect_1.Request.TaggedClass('@fixtuur/gavel-client/SpacesRequest') {
}
exports.GetSpaces = GetSpaces;
const GetSpacesResolver = (http) => effect_1.RequestResolver.fromEffect(({ baseUrl, tenantId, productId }) => {
    const url = new URL(`/api/v1/${tenantId}/spaces`, baseUrl).toString();
    const params = Object.assign({}, productId ? { productId: productId } : {});
    return http
        .get(url, {
        urlParams: params
    })
        .pipe(effect_1.Effect.flatMap(response => response.json), effect_1.Effect.flatMap(effect_1.Schema.decodeUnknown(GetSpacesResponse)), effect_1.Effect.catchAll(originalError => new errors_1.ServiceError({ originalError })), effect_1.Effect.scoped);
});
exports.GetSpacesResolver = GetSpacesResolver;
class GetOptions extends effect_1.Request.TaggedClass('@fixtuur/gavel-client/OptionsRequest') {
}
exports.GetOptions = GetOptions;
const GetOptionsResponse = effect_1.Schema.Struct({
    properties: types_1.PropertyOptions,
});
const GetOptionsResolver = (http) => effect_1.RequestResolver.fromEffect((_a) => {
    var { baseUrl, selections, tenantId } = _a, options = __rest(_a, ["baseUrl", "selections", "tenantId"]);
    const url = new URL(`/api/v1/${tenantId}/options`, baseUrl).toString();
    const params = Object.assign({}, { selections: rison_1.default.encode_object(selections) }, options.filterMode ? { filterMode: options.filterMode } : {}, options.templateId ? { template: options.templateId } : {}, options.spaceId ? { space: options.spaceId } : {});
    return http
        .get(url, {
        acceptJson: true,
        urlParams: params,
    })
        .pipe(effect_1.Effect.flatMap(response => response.json), effect_1.Effect.flatMap(effect_1.Schema.decodeUnknown(GetOptionsResponse)), effect_1.Effect.map(({ properties }) => properties), effect_1.Effect.catchAll(originalError => new errors_1.ServiceError({ originalError })), effect_1.Effect.scoped);
});
exports.GetOptionsResolver = GetOptionsResolver;
const PostSelectionsResponse = effect_1.Schema.Struct({
    options: effect_1.Schema.Struct({ properties: types_1.PropertyOptions }),
    selections: types_1.PropertySelections,
});
class PostSelections extends effect_1.Request.TaggedClass('@fixtuur/gavel-client/PostSelectionsRequest') {
}
exports.PostSelections = PostSelections;
const PostSelectionsResolver = (http) => effect_1.RequestResolver.fromEffect(({ baseUrl, proposals, tenantId, filterMode, spaceId, templateId }) => {
    const url = new URL(`/api/v1/${tenantId}/selections`, baseUrl).toString();
    const body = JSON.stringify({ proposals: rison_1.default.encode_array(proposals) });
    const query = Object.assign({}, filterMode ? { filterMode } : {}, templateId ? { template: templateId } : {}, spaceId ? { space: spaceId } : {});
    return http
        .post(url, {
        urlParams: query,
        body: HttpBody.raw(body),
        headers: { 'content-type': 'application/json' },
    })
        .pipe(effect_1.Effect.flatMap(response => response.json), effect_1.Effect.flatMap(effect_1.Schema.decodeUnknown(PostSelectionsResponse)), effect_1.Effect.catchAll(originalError => new errors_1.ServiceError({ originalError })), effect_1.Effect.scoped);
});
exports.PostSelectionsResolver = PostSelectionsResolver;
const GetConfigurationResponse = effect_1.Schema.Struct({
    next: effect_1.Schema.optional(effect_1.Schema.Union(types_1.Cursor, effect_1.Schema.Null)),
    configurations: effect_1.Schema.Array(types_1.Configuration),
});
class GetConfigurations extends effect_1.Request.TaggedClass('@fixtuur/gavel-client/GetConfigurationsRequest') {
}
exports.GetConfigurations = GetConfigurations;
const GetConfigurationsResolver = (http) => effect_1.RequestResolver.fromEffect(({ baseUrl, selections, tenantId, count, cursor, spaceId, templateId, }) => {
    const url = new URL(`/api/v1/${tenantId}/configurations`, baseUrl);
    const params = Object.assign({}, { selections: rison_1.default.encode_object(selections) }, count ? { count } : {}, cursor ? { cursor } : {}, spaceId ? { space: spaceId } : {}, templateId ? { template: templateId } : {});
    return http
        .get(url, {
        urlParams: params,
    })
        .pipe(effect_1.Effect.flatMap(response => response.json), effect_1.Effect.flatMap(effect_1.Schema.decodeUnknown(GetConfigurationResponse)), effect_1.Effect.catchAll(originalError => new errors_1.ServiceError({ originalError })), effect_1.Effect.scoped);
});
exports.GetConfigurationsResolver = GetConfigurationsResolver;
